import { timeFormat } from 'd3-time-format';
export default timeFormat('%b %d');
